import {
  MOBILE_CHECKOUT_SUMMARY_VISIBLE,
  MOBILE_CHECKOUT_SUMMARY_NOT_VISIBLE
} from './constants';

const INITIAL_STATE = {
  isMobileOrderSummaryVisible: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MOBILE_CHECKOUT_SUMMARY_VISIBLE: {
      return {
        ...state,
        isMobileOrderSummaryVisible: true
      };
    }
    case MOBILE_CHECKOUT_SUMMARY_NOT_VISIBLE: {
      return {
        ...state,
        isMobileOrderSummaryVisible: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
